import { Component, computed, inject } from '@angular/core';
import { CartItemStateService } from '../../../services/cart-item-state.service';
import { LibModulesWolcModule } from '../../lib-modules-wolc.module';

@Component({
  selector: 'btlib-order-pool-units',
  standalone: true,
  imports: [LibModulesWolcModule],
  templateUrl: './order-pool-units.component.html',
  styleUrl: './order-pool-units.component.scss'
})
export class BtOrderPoolUnitsComponent {
  state = inject(CartItemStateService);
  poolUnits = this.state.poolUnits;

  selectedUnitId = computed(() => {
    return this.poolUnits().find(p => p.selected)?.unitId ?? null;
  });

  select(unitId: number | null): void {
    this.state.selectPoolUnit(unitId);
  }
}
